import request from '@/utils/request';

//获取导航
export async function banksNav(): Promise<any> {
  return request('/api/v1/pb/banks');
}

//获取导航
export async function channelNav(params: any): Promise<any> {
  return request(`/api/v1/pb/banks/${params}`);
}

//获取频道元信息
export async function channelTab(params: any): Promise<any> {
  return request(`/api/v1/pb/subjects/${params}`);
}
